// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2RyFp","info":"Note_info__22WDM","note":"Note_note__SJlb9","actions":"Note_actions__1fCKR"};